import { call, put } from "redux-saga/effects";
import { apiGeneral, notify, queryBuilder } from "services";
import { IListRequest } from "interfaces/list-duck";
import { requestErrorHandler } from "utils";
import { ListSapTypesActions } from "store/ducks/sap-types";

import { ISapType } from "interfaces/sap-type";

export function* listSapTypesRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IListRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(apiGeneral.get, `/sap-types/options?${queryString}`);
    let comboOptions = [];
    if (!!data.length) {
      comboOptions = data?.map((sapType: ISapType) => ({
        value: sapType.id,
        label: sapType.name,
        id: sapType.id,
      }));
    }

    yield put(ListSapTypesActions.success(comboOptions));
    if (onSuccess) onSuccess(comboOptions);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ListSapTypesActions.failure(errorMessage));
  }
}

